const PRICING_API = "/api/commerce/pricing";

const getPricingBlocks = () =>
    Array.from(document.querySelectorAll("[data-part-add-to-cart], [data-part-please-enquire]"))
        .map((el) => el.closest("[data-catalog-number]"))
        .filter((el, i, arr) => el && arr.indexOf(el) === i);

const getSaleablePartNumbers = (blocks) =>
    blocks
        .map((block) => block.getAttribute("data-catalog-number"))
        .filter(Boolean);

const hideSpinnerForPart = (partNumber) => {
    const spinner = document.querySelector(`[data-part-loading="${partNumber}"]`);
    if (spinner) spinner.style.display = "none";
};

const showFallbackButtons = () => {
    document.querySelectorAll("[data-part-loading]").forEach((spinner) => {
        if (spinner.style.display !== "none") {
            spinner.style.display = "none";
            const partNumber = spinner.getAttribute("data-part-loading");
            const pleaseEnquireBtn = document.querySelector(`[data-part-please-enquire="${partNumber}"]`);
            if (pleaseEnquireBtn) pleaseEnquireBtn.style.display = "";
        }
    });
};

const applyPricingResult = (result) => {
    const partNumber = result.PartNumber;

    hideSpinnerForPart(partNumber);

    // Tile view: single customer price element
    const priceEl = document.querySelector(`[data-part-price="${partNumber}"]`);
    // Table view: separate list price and customer price elements
    const listPriceEl = document.querySelector(`[data-part-list-price="${partNumber}"]`);
    const customerPriceEl = document.querySelector(`[data-part-customer-price="${partNumber}"]`);

    const addToCartBtn = document.querySelector(`[data-part-add-to-cart="${partNumber}"]`);
    const pleaseEnquireBtn = document.querySelector(`[data-part-please-enquire="${partNumber}"]`);
    const quantityContainer = document.querySelector(`[data-part-quantity="${partNumber}"]`);

    if (!addToCartBtn && !pleaseEnquireBtn) return;

    if (result.AvailableForSale) {
        // Tile view price
        if (priceEl) {
            priceEl.innerHTML = result.CustomerPrice || "";
        }

        // Table view prices
        if (listPriceEl) {
            const valueSpan = listPriceEl.querySelector("span");
            if (valueSpan) valueSpan.textContent = result.ListPrice || "";
            listPriceEl.style.display = "";
        }
        if (customerPriceEl) {
            const valueSpan = customerPriceEl.querySelector("[data-customer-price-value]");
            if (valueSpan) valueSpan.textContent = result.CustomerPrice || "";
            customerPriceEl.style.display = "";
        }

        // Update the outer element's data-price for any consumers (e.g. analytics, sticky header)
        const block = (addToCartBtn || pleaseEnquireBtn).closest("[data-catalog-number]");
        if (block) {
            block.setAttribute("data-price", result.ListPrice || "");
        }

        if (addToCartBtn) {
            addToCartBtn.style.display = "";
            if (pleaseEnquireBtn) pleaseEnquireBtn.style.display = "none";
        } else if (pleaseEnquireBtn) {
            pleaseEnquireBtn.style.display = "";
        }

        if (quantityContainer) {
            quantityContainer.style.display = "";
        }
    } else {
        if (priceEl) {
            priceEl.style.display = "none";
        }
        // listPriceEl and customerPriceEl remain display:none (already hidden)
        if (pleaseEnquireBtn) {
            pleaseEnquireBtn.style.display = "";
        }
    }
};

const updateStickyPriceDisplay = (catalogNumber) => {
    const safeCatalogNumber = catalogNumber.toUpperCase().replace(/ /g, "-");
    const priceEl = document.querySelector(`[id^="AddToCart${safeCatalogNumber}"] .product-price`);
    const stickyPriceEl = document.querySelector(".product-info-container .product-price");
    const stickyCatalogEl = document.querySelector(
        ".product-info-container .product-catalog-number .catalog-number"
    );

    if (!stickyPriceEl) return;

    if (priceEl && priceEl.innerHTML) {
        stickyPriceEl.classList.remove("hidden-from-display");
        stickyPriceEl.classList.add("display-as-block");
        stickyPriceEl.textContent = priceEl.textContent;
    } else {
        stickyPriceEl.classList.add("hidden-from-display");
    }

    if (stickyCatalogEl) {
        stickyCatalogEl.textContent = catalogNumber.toUpperCase();
    }
};

const showLoginPromptIfNeeded = (results) => {
    const anyAvailable = results.some((r) => r.AvailableForSale);
    if (anyAvailable) {
        const loginPrompt = document.querySelector(".product-login-prompt");
        if (loginPrompt) {
            loginPrompt.style.display = "";
        }
    }
};

const getAntiForgeryToken = () =>
    document.querySelector('input[name="__RequestVerificationToken"]')?.value;

const fetchAndApplyPricing = async (partNumbers) => {
    try {
        const queryString = partNumbers.map(encodeURIComponent).join(",");
        const response = await fetch(`${PRICING_API}?parts=${queryString}`, {
            credentials: "same-origin",
            headers: { "X-XSRF-Token": getAntiForgeryToken() || "" },
        });

        if (!response.ok) {
            showFallbackButtons();
            return;
        }

        const results = await response.json();
        results.forEach(applyPricingResult);
        showFallbackButtons(); // clean up any spinners for parts not in the response
        showLoginPromptIfNeeded(results);

        // Refresh the sticky price display for whichever block is currently visible
        const visibleBlock = document.querySelector("[id^='AddToCart']:not(.hidden-from-display)");
        if (visibleBlock) {
            updateStickyPriceDisplay(visibleBlock.getAttribute("data-catalog-number"));
        }
    } catch {
        showFallbackButtons();
    }
};

document.addEventListener("DOMContentLoaded", () => {
    const blocks = getPricingBlocks();
    if (blocks.length === 0) return;

    const partNumbers = getSaleablePartNumbers(blocks);
    if (partNumbers.length === 0) return;

    fetchAndApplyPricing(partNumbers);
});
